import { CONSENT_STATUS } from "@utils/enum";

export const IconDetailsByStatus = {
  [CONSENT_STATUS.PENDING]: { name: "sign", color: "var(--yellow-medium)" },
  [CONSENT_STATUS.COMPLETED]: {
    name: "tick-mark",
    color: "var(--green-dark)",
    textColor: "var(--white)",
  },
  [CONSENT_STATUS.EXPIRED]: {
    name: "rubber",
    color: "var(--red-medium)",
    textColor: "var(--white)",
  },
};

export const TextDetailsByStatus = {
  [CONSENT_STATUS.PENDING]: {
    titleKey: "title_your_consent_needed",
    descriptionKey: "description_your_consent_needed",
  },
  [CONSENT_STATUS.COMPLETED]: {
    titleKey: "consent_status_given_title",
    descriptionKey: "",
  },
  [CONSENT_STATUS.EXPIRED]: {
    titleKey: "consent_status_expired_title",
    descriptionKey: "consent_label_expired",
  },
};
